<template lang="pug">
div.techSupport-menu(:class="{'techSupport-menu-show': show && !isMiniApp}")
  v-expand-transition
    v-list(v-if="show" :class="!isMiniApp ? 'mx-2' : 'py-0'")
      v-list-item-group(active-class="menu-active")
        v-list-item(v-for="(item, i) in items" :key="i" @click="item.action" :class="{'py-3': isMiniApp}")
          div(class="menu-icon" :class="{'mr-3': !isMiniApp}").menu-icon
            img(:src="item.icon" width="22")
          v-list-item-content
            v-list-item-title(v-text="item.title")

  div(@click="toggleMenu" v-ripple :class="{'pl-5 list-mini': isMiniApp }").custom-list-item.pl-2.pb-5.pt-3.pr-5
    div.d-flex
      div(:class="{'mr-4': !isMiniApp }").menu-icon
        img(:src="headset" width="20")
      div(v-if="!isMiniApp") {{ $t('techSupport.buttonLabel') }}
    div
      img(:src="show ? arrowTop : arrowBottom" :class="{'techSupport-menu-arrow': isMiniApp }")

  v-dialog(
    v-model="isShowModal"
    width="600"
    scrollable
    @click:outside="toggleModal"
  )
    TechSupportForm(v-if="isShowModal" @close="toggleModal")

</template>

<script>
import { mapActions, mapState } from 'vuex'
import headset from '@/assets/icons/headset.svg'
import chat from '@/assets/icons/chat-action-button.svg'
import form from '@/assets/icons/form-action-button.svg'
import arrowBottom from '@/assets/icons/arrow-bottom.svg'
import arrowTop from '@/assets/icons/arrow-top.svg'
import TechSupportForm from '@/components/TechSupport/TechSupportForm.vue'

export default {
  name: 'TechSupportButton',
  components: {
    TechSupportForm
  },
  data() {
    return {
      items: [
        { title: this.$t('techSupport.buttonChatLabel'), icon: chat, action: this.toggleChat },
        { title: this.$t('techSupport.buttonFormLabel'), icon: form, action: this.toggleModal }
      ],
      isShowModal: false,
      show: false,
      headset,
      arrowBottom,
      arrowTop
    }
  },

  computed: {
    ...mapState({
      isMiniApp: state => state.app.isMini
    })
  },

  methods: {
    ...mapActions(['clearInquiryTechSupport']),

    toggleMenu () {
      this.show = !this.show
    },
    toggleModal () {
      this.isShowModal = !this.isShowModal
      if (!this.isShowModal) this.clearInquiryTechSupport()
    },
    toggleChat () {
      window.$chatwoot.toggle()
    }
  }
}
</script>
